<div class="container-fluid h-100">
  <div class="row h-100 ">
    <div class="col-auto bg-white h-100 d-none d-lg-block">
      <Sidebar ref="sidebar"></Sidebar>
    </div>
    <div class="col bg-white h-100 m-0">
      <Navbar @toggle-sidebar="toggleSidebar" class="bg-white w-100"></Navbar>
      <div class="m-0 bg-gray px-4 py-1 h-100">
        <div class="row mt-4">
          <div class="col-md-3 mb-2">
              <div class="visitor-card">
                  <div class="d-flex align-items-center gap-3">
                    <div class="icon-box bg-gradient-orange">
                      <i class='bx bxs-user'></i>
                    </div>
                    <div>
                      <div class="text-xs fw-bold">{{ total_users }}</div>
                       <div class="text-muted text-xs">Total Users</div>
                    </div>
                  </div>
                  <div class="details-link">
                    <span class="text-xxs"><a href="/create_user" class="text-decoration-none text-muted"><i class="bi bi-eye"></i> View</a></span>
                    <i class="fas fa-arrow-right"></i>
                  </div>
                </div>
          </div>
          <div class="col-md-3 mb-2">
              <div class="visitor-card">
                  <div class="d-flex align-items-center gap-3">
                    <div class="icon-box bg-gradient-green">
                      <i class='bx bxs-user'></i>
                    </div>
                    <div>
                      <div class="text-xs fw-bold"> {{ total_portals }}</div>
                       <div class="text-muted text-xs">Total Portals</div>
                    </div>
                  </div>
                  <div class="details-link">
                    <span class="text-xxs"><a href="/create_portal" class="text-decoration-none text-muted"><i class="bi bi-eye"></i> View</a></span>
                    <i class="fas fa-arrow-right"></i>
                  </div>
                </div>
          </div>
          <div class="col-md-3">
              <div class="visitor-card">
                  <div class="d-flex align-items-center gap-3">
                    <div class="icon-box bg-gradient-blue">
                      <i class='bx bxs-user'></i>
                    </div>
                    <div>
                      <div class="text-xs fw-bold"> {{ total_reports }}</div>
                       <div class="text-muted text-xs">Total Reports</div>
                    </div>
                  </div>
                  <div class="details-link">
                    <span class="text-xxs"><a href="/create_portal" class="text-decoration-none text-muted"><i class="bi bi-eye"></i> View</a></span>
                    <i class="fas fa-arrow-right"></i>
                  </div>
                </div>

          </div>
          <div class="col-md-3">
              <div class="visitor-card">
                  <div class="d-flex align-items-center gap-3">
                    <div class="icon-box bg-gradient-blue">
                      <i class='bx bxs-user'></i>
                    </div>
                    <div>
                      <div class="text-xs fw-bold"> {{ total_events }}</div>
                       <div class="text-muted text-xs">Total Events</div>
                    </div>
                  </div>
                  <div class="details-link">
                    <span class="text-xxs"><a href="/events" class="text-decoration-none text-muted"><i class="bi bi-eye"></i> View</a></span>
                    <i class="fas fa-arrow-right"></i>
                  </div>
                </div>

          </div>

          <div v-if="!dwypd_domain" class="col-md-3">
              <div class="visitor-card">
                  <div class="d-flex align-items-center gap-3">
                    <div class="icon-box bg-gradient-blue">
                      <i class='bx bxs-user'></i>
                    </div>
                    <div>
                      <div class="text-xs fw-bold"> {{ total_memberships }}</div>
                       <div class="text-muted text-xs">Total Memberships</div>
                    </div>
                  </div>
                  <div class="details-link">
                    <span class="text-xxs"><a href="/create_membership" class="text-decoration-none text-muted"><i class="bi bi-eye"></i> View</a></span>
                    <i class="fas fa-arrow-right"></i>
                  </div>
                </div>

          </div>

          <div class="col-md-3">
              <div class="visitor-card">
                  <div class="d-flex align-items-center gap-3">
                    <div class="icon-box bg-gradient-blue">
                      <i class='bx bxs-user'></i>
                    </div>
                    <div>
                      <div class="text-xs fw-bold"> {{ total_business_profiles }}</div>
                       <div class="text-muted text-xs">Total Business Profiles</div>
                    </div>
                  </div>
                  <div class="details-link">
                    <span class="text-xxs"><a href="/view_business_dashboard" class="text-decoration-none text-muted"><i class="bi bi-eye"></i> View</a></span>
                    <i class="fas fa-arrow-right"></i>
                  </div>
                </div>

          </div>
      </div>
      </div>
     
    </div>
  
    </div>
</div>
